import KendoDialog from './KendoDialog'
import KendoDialogAction from './KendoDialog/KendoDialogAction'
import KendoDialogInstaller from './kendo-dialog-installer'

export { KendoDialog, KendoDialog as Dialog, KendoDialogAction, KendoDialogAction as DialogAction, KendoDialogInstaller, KendoDialogInstaller as DialogInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/index.js